export const ENTITY_LOGIN_ROUTE = '/inmobiliaria/login';
export const ENTITY_CLIENTS_ROUTE = '/inmobiliaria/clients';
export const AGENTE_LOGIN_ROUTE = '/agente/login';
export const AGENTE_REGISTRO_ROUTE = '/agente/registro';
export const AGENTE_CLIENTS_ROUTE = '/agente/clients';
export const AGENTE_CLIENTS_CREATE_ROUTE = '/agente/clients/create';
export const AGENTE_PERFILADOR_ROUTE = '/agente/perfilador';
export const ENTITY_PERFILAMIENTO_INMOBILIARIA_ROUTE = '/inmobiliaria/perfilamiento?inmobiliaria=';
export const AGENTE_COTIZACION_LEAD_ROUTE = (entityId, leadId, agenteId) => `/inmobiliaria/perfilamiento?inmobiliaria=${entityId}&lead=${leadId}&agente=${agenteId}`;
